import { render, staticRenderFns } from "./DetailsCardDialog.vue?vue&type=template&id=4449e474&scoped=true"
import script from "./DetailsCardDialog.vue?vue&type=script&lang=js"
export * from "./DetailsCardDialog.vue?vue&type=script&lang=js"
import style0 from "./DetailsCardDialog.vue?vue&type=style&index=0&id=4449e474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449e474",
  null
  
)

export default component.exports